export default "__VITE_ASSET__DcnfxNGr__"